<template>
    <div>

        <b-row>
            <b-col cols="auto">
              <b-form-group>
                  <label for="company" style="font-size: 0.8em">Tipo de Projeto</label>
                  <b-form-select id="type"
                    v-model="filters.typeId"
                    :plain="true"
                    :options="selectTypeDDL"
                    @change="getType"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            
            </b-col>

            <b-col cols="auto">
              <b-form-group>
                  <label for="code" style="font-size: 0.8em">Código</label>
                  <b-form-input v-model="filters.code" type="text" id="code" placeholder="Código"></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols="auto">
              <b-form-group>
                  <label for="filter" style="font-size: 0.8em">Filtro</label>
                  <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
              </b-form-group>
            </b-col>
           
            <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
              <b-form-group>
                <p></p>
                <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
              </b-form-group>
            </b-col>

            <b-col cols="auto" class="">
              <b-form-group >
                  <label for="perPage" style="font-size: 0.8em">Linhas</label>
                  <b-form-select v-model="productTable.perPage" id="perPage"
                    :plain="true"
                    :options="[5,10,20,50]">
                  </b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
        
    
        <b-table 
            :items="productItems" 
            :fields="productTable.fields" 
            :select-mode="productTable.selectMode" 
            responsive="sm" 
            selectable
            :primary-key="productTable.primaryKey"
            :tbody-transition-props="productTable.transProps" 
            sort-icon-left
            :per-page="productTable.perPage"
            :current-page="productTable.currentPage"
            :busy="productTable.isBusy"
            hover
            striped
            style="min-height: 200px;"
            @row-selected="onRowSelected"
            >
                
            <template #table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Carregando...</strong>
                </div>
            </template>
                            
            <!-- Example scoped slot for select state illustrative purposes -->
            <template #cell(selected)="{ rowSelected }">
                <template v-if="rowSelected">
                                    <span aria-hidden="true">&check;</span>
                                    <span class="sr-only">Selected</span>
                </template>
                <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    
                    <span class="sr-only">Not selected</span>
                </template>
            </template>

            <template v-slot:cell(createdIn)="data">
                {{ $utils.localDateTimeShort( data.item.createdIn ) }}
            </template>

            <template v-slot:cell(unitaryValue)="data">
                {{ data.item.unitaryValue ? data.item.unitaryValue.toFixed(2) : "" }}
            </template>

            <template v-slot:cell(action)="data">
                <b-button size="sm" variant="primary" @click="openFileModal(data.item)" class="mr-1 btn-brand"><i class="fa fa-file-pdf-o"></i></b-button>
                
            </template>


        </b-table>
        <nav>
            <b-pagination :total-rows="totalRows" :per-page="productTable.perPage" v-model="productTable.currentPage" prev-text="Anterior" next-text="Próximo" />
        </nav>
      
    </div>
</template>

<script>
import Vue from 'vue'
import axios from "axios";

export default {
    name: 'productSelectComponent',
    props: {
        companyId: String
    },
    components: {
       
    },
    data: () => {
        return {

            typeDDL: [],

            
            filters: {
                code: "",
                key: "",
                typeId: 0
            },
            productItems: [],
            productTable: {
                fields: [
                    { key: 'code', label: 'Código', sortable: true, thStyle: { width: "100px" } },
                    { key: 'name', label: 'Produto', sortable: true },
                    { key: 'unitaryValue', label: 'Valor', sortable: true, thStyle: { width: "150px" }, tdClass: 'text-right'},
                    //{ key: 'quantity', label: 'Quantidade', sortable: true, thStyle: { width: "100px" }},
                                   
                ],
                selectMode: 'single',
                isBusy: false,
                primaryKey: "id",
                transProps: {
                    name: 'flip-list'
                },
                perPage: 10,
                currentPage: 1

            }

        }
    },
    computed: {
        totalRows: function () { return this.getRowCount() },
        selectTypeDDL: function() {
            var list = [...this.typeDDL]
            list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
            list.unshift({ value: '0' , text: '- Todos -' })
            return list
        },
    },
    methods: {
        getRowCount: function () {
            if(this.productItems)
                return this.productItems.length
            else
                return 0;
        },

        async getType() {
            var s = this;
            var currentUser = this.$store.state.currentUser;
            
            await axios.get(
                this.$store.state.ws_url + "/product/type/ddl?companyId=" + s.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function(resp) {
                s.typeDDL = resp.data.obj;
                
            }).catch(function(error) {
                console.log(error)
            })
        },

        async getProduct() {
            var s = this;
            var currentUser = this.$store.state.currentUser;
            
            if((s.filters.code && s.filters.code.length > 0) || (s.filters.key && s.filters.key.length > 0)) {

                console.log( this.$store.state.ws_url + "/product?companyId=" + s.companyId + "&code=" + s.filters.code + "&key=" + s.filters.key + "&uid=" + currentUser.id + "&sid=" + currentUser.sid )

                await axios.get(
                    this.$store.state.ws_url + "/product?companyId=" + s.companyId + "&code=" + s.filters.code + "&key=" + s.filters.key + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
                ).then(function(resp) {
                    s.productItems = resp.data.obj;
                }).catch(function(error) {
                    console.log(error)
                })
            }
            else {
                s.productItems = []
            }            
        },

        refreshData() {
            this.getType()
            this.getProduct()
        },

        onRowSelected(items) {
            this.selected = items
            console.log(items);
            this.$emit('product-selected', items)
        },
        
        
    },
    mounted: function() {
      this.companyDDL = this.$store.state.currentUser.companies
      this.refreshData()
    }

}

</script>